import React, { Fragment, useEffect, useState, useContext, useRef } from "react";
import { RestHelper } from "../../helper/restHelper";
import { UserContext } from "../../app"

const AdminEditCreatedRequest = ({ requestId, searchStatus, onEditComplete }) => {

    const { userProfile, setUser } = useContext(UserContext)
    const [request, setRequest] = useState({
        apptName: "",
        apptDate: "",
        apptTime: "",
        apptTimeTBD: false,
        apptTimeZone: "CT",
        apptStreet: "",
        apptCity: "",
        apptState: "",
        apptZip: "",
        apptOffer: "",
        email: "",
        comments: "",
        apptLender: "",
        fileNumber: "",
        userProfile: "",
        contactName: "",
        contactPhone1: "",
        contactPhone2: "",
        contactEmail1: "",
        contactEmail2: "",
        unique_id: "",
        appt_fee: "",
        assigned_notary: "",
        appt_status: "",
        scanBack: false,
        transactionType: "",
        financeType: ""
    })
    const [profileLoaded, setProfileLoaded] = useState(false)
    const [editFlag, setEditFlag] = useState(false)
    const [notaryFeeEditFlag, setNotaryFeeEditFlag] = useState(true)
    const [errorMessage, setErrorMessage] = useState(false)
    const [showForm, setShowForm] = useState(true)
    const [apiMessage, setApiMessage] = useState('')
    const [apiDetails, setApiDetails] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [requireTime, setRequireTime] = useState(true)
    const [editedContent, setEditedContent] = useState(false)

    const commentsRef = useRef(null)
    const api = RestHelper()

    useEffect(() => {
        if (!isLoaded) {
            setIsLoading(true)
            setShowForm(false)
            const reqData = { 'action': 'get', 'request_id': requestId }
            const options = {}
            api
                .postCreate('/manage-appts-admin', options, reqData)
                .then(res => initialLoad(res))
                .catch(err => console.log(err))
        }
    }, [])

    const initialLoad = (res) => {
        setRequest(prev => ({
            ...prev,
            apptName: res['appt_name'] ?? '',
            apptDate: res['appt_date'] ?? '',
            apptTime: res['appt_time'] ?? '',
            apptTimeTBD: res['appt_time_TBD'] ?? false,
            apptTimeZone: res['appt_timeZone'] ?? 'CT',
            apptStreet: res['appt_address'] ?? '',
            apptCity: res['appt_city'] ?? '',
            apptState: res['appt_state'] ?? '',
            apptZip: res['appt_zip'] ?? '',
            apptOffer: res['appt_offer'] ?? '',
            email: res['appt_escrow_email'] ?? '',
            appt_firm_name: res['appt_firm_name'] ?? '',
            appt_escrow: res['appt_escrow'] ?? '',
            comments: res['appt_notes'] ?? '',
            fileNumber: res['fileNumber'] ?? '',
            apptLender: res['appt_lender'] ?? '',
            userProfile: res['userProfile'] ?? '',
            contactName: res['appt_contactName'] ?? '',
            contactPhone1: res['appt_contactPhone1'] ?? '',
            contactPhone2: res['appt_contactPhone2'] ?? '',
            contactEmail1: res['appt_contactEmail1'] ?? '',
            contactEmail2: res['appt_contactEmail2'] ?? '',
            unique_id: res['unique_id'] ?? '',
            appt_fee: res['appt_fee'] ?? '',
            assigned_notary: res['assigned_notary'] ?? '',
            appt_status: res['appt_status'] ?? '',
            scanBack: res['scanBack'] ?? false,
            transactionType: res['transactionType'] ?? '',
            financeType: res['financeType'] ?? ''
        }))

        setIsLoading(false)
        setShowForm(true)
        setEditFlag(true)
        if (res['appt_time_TBD']) {
            setRequireTime(false)
        }
        setIsLoaded(true)
    }

    const onChangeEvent = (evt) => {
        setEditedContent(true)
        var value = evt.target.value;
        // Use name for radio buttons, id for other inputs
        var fieldName = evt.target.type === 'radio' ? evt.target.name : evt.target.id;
        if (fieldName == 'apptOffer') {
            value = value.replace('$', '')
        }
        if (fieldName == 'appt_fee') {
            value = value.replace('$', '')
        }
        setRequest({
            ...request,
            [fieldName]: value
        })
    }

    const setScanBack = (initialValue) => {
        if (initialValue === 'true') {
            var radioButton = document.querySelector("input[value='true']")
            radioButton.checked = true;
        }
        else {
            var radioButton = document.querySelector("input[value='false']")
            radioButton.checked = true;
        }
    }

    const setTransactionType = (initialValue) => {
        if (initialValue === '1') {
            var radioButton = document.querySelector("input[value='1']")
            radioButton.checked = true;
        }
        else if (initialValue === '2') {
            var radioButton = document.querySelector("input[value='2']")
            radioButton.checked = true;
        }
        else if (initialValue === '3') {
            var radioButton = document.querySelector("input[value='3']")
            radioButton.checked = true;
        }
        else if (initialValue === '4') {
            var radioButton = document.querySelector("input[value='4']")
            radioButton.checked = true;
        }
    }

    const setFinanceType = (initialValue) => {
        if (initialValue === '11') {
            var radioButton = document.querySelector("input[value='11']")
            radioButton.checked = true;
        }
        else if (initialValue === '12') {
            var radioButton = document.querySelector("input[value='12']")
            radioButton.checked = true;
        }
        else if (initialValue === '13') {
            var radioButton = document.querySelector("input[value='13']")
            radioButton.checked = true;
        }
        else if (initialValue === '14') {
            var radioButton = document.querySelector("input[value='14']")
            radioButton.checked = true;
        }
        else if (initialValue === '15') {
            var radioButton = document.querySelector("input[value='15']")
            radioButton.checked = true;
        }
        else if (initialValue === '16') {
            var radioButton = document.querySelector("input[value='16']")
            radioButton.checked = true;
        }
    }

    const setCheckBox = (initialValue) => {
        const checkboxArray = ['apptTimeTBD']
        checkboxArray.forEach(value => {
            const checkBoxVar = document.getElementById(value)
            if (initialValue) {
                if (initialValue != checkBoxVar.checked) {
                    checkBoxVar.click()
                }
            }
        })
    }

    const stateOptions = ['', 'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI',
        'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC',
        'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX',
        'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY']

    useEffect(() => {
        setRequest(prev => ({
            ...prev,
            userProfile: userProfile.profileEmail
        }))
    }, [isLoaded]);

    const clearErrorMessage = () => {
        setErrorMessage(false)
        if (onEditComplete) {
            onEditComplete()
        } else {
            setShowForm(true)
            setProfileLoaded(!profileLoaded)
        }
    }

    const updateTimeFieldInitial = (value) => {
        if (value) {
            setRequireTime(false)
            setRequest({
                ...request,
                ['apptTime']: '00:00'
            })
        }
    }

    const updateTimeField = () => {
        if (requireTime) {
            setRequireTime(false)
            setRequest({
                ...request,
                ['apptTime']: '00:00',
                ['apptTimeTBD']: true
            })
        }
        else {
            setRequireTime(true)
            setRequest({
                ...request,
                ['apptTime']: '',
                ['apptTimeTBD']: false
            })
        }
    }

    const addState = (evt) => {
        const value = evt.target.id
        setRequest({
            ...request,
            [value]: evt.target.value
        })
    }

    const setApiRes = (res) => {
        setErrorMessage(true)
        setShowForm(false)
        setIsLoading(false)
        setApiDetails(res['details'])
        setApiMessage(res['returnMessage'])
    }

    const updateEditFlags = (e) => {
        setEditFlag(e)
        setNotaryFeeEditFlag(e)
    }

    const callApi = () => {
        const options = {}
        const reqData = { 'action': 'edit', 'request_id': requestId, 'data': request }
        setIsLoading(true)
        setShowForm(false)
        setEditedContent(false)
        api
            .postCreate('/manage-appts-admin', options, reqData)
            .then(res => setApiRes(res))
            .catch(err => setApiRes(err))
    }

    const setFee = () => {
        const fee = '$' + request.apptOffer
        return fee
    }

    const setServiceFee = () => {
        const fee = '$' + request.appt_fee
        return fee
    }

    const onSubmitHandler = (event) => {
        event.preventDefault();
        if (notaryFeeEditFlag) {
            setEditFlag(false)
            setNotaryFeeEditFlag(false)
        }
        else {
            callApi()
            setEditFlag(true)
            setNotaryFeeEditFlag(true)
        }
    }

    const autoResizeComments = (el) => {
        if (!el) return;
        el.style.height = '1px';
        el.style.height = el.scrollHeight + 'px';
    }


    const inputClass = "w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
    const inputReadOnlyClass = "w-full px-3 py-2 border border-neutral-200 rounded-lg bg-neutral-50 text-neutral-600"
    const labelClass = "block text-sm font-medium text-neutral-700 mb-1"
    const selectClass = "w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"

    return (
        <Fragment>
            {errorMessage && (
                <div className="bg-white rounded-xl shadow-md border border-neutral-200 mb-4 overflow-hidden">
                    <div className="px-4 py-3 border-b border-neutral-200 flex justify-between items-center">
                        <h2 className="text-lg font-semibold text-neutral-800">Appointment Status</h2>
                        <button
                            className="text-neutral-400 hover:text-neutral-600 p-1"
                            onClick={() => clearErrorMessage()}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div className="p-4 sm:p-6">
                        <p className="text-neutral-700 mb-2">{apiMessage}</p>
                        <p className="font-medium text-neutral-800">{apiDetails}</p>
                    </div>
                </div>
            )}

            {showForm && (
                <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                    <div className="px-4 sm:px-6 py-4 border-b border-neutral-200">
                        <h2 className="text-lg font-semibold text-neutral-800">Review and Edit {searchStatus} Appointment</h2>
                        <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
                    </div>
                    <div className="p-4 sm:p-6">
                        <form onSubmit={(e) => onSubmitHandler(e)}>
                            {/* Event Details Section */}
                            <div className="bg-neutral-50 rounded-lg border border-neutral-200 p-4 mb-6">
                                <h3 className="text-base font-semibold text-neutral-800 mb-4">Event Details (* required)</h3>

                                {/* Appointment Name */}
                                <div className="mb-4">
                                    <label htmlFor="apptName" className={labelClass}>Appointment Name *</label>
                                    <input
                                        className={editFlag ? inputClass : inputReadOnlyClass}
                                        id="apptName"
                                        onChange={(e) => onChangeEvent(e)}
                                        type="text"
                                        value={request.apptName}
                                        required
                                        readOnly={!editFlag}
                                    />
                                </div>

                                {/* Date, Time TBD, Time, Timezone */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                                    <div>
                                        <label htmlFor="apptDate" className={labelClass}>Date *</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="apptDate"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="date"
                                            value={request.apptDate}
                                            required
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                    <div className="flex items-center pt-6">
                                        <input
                                            className="h-4 w-4 text-blue-600 border-neutral-300 rounded focus:ring-blue-500"
                                            type="checkbox"
                                            id="apptTimeTBD"
                                            checked={request.apptTimeTBD}
                                            onChange={() => { updateTimeField() }}
                                            disabled={!editFlag}
                                        />
                                        <label className="ml-2 text-sm text-neutral-700">Time TBD</label>
                                    </div>
                                    <div>
                                        <label htmlFor="apptTime" className={labelClass}>Time *</label>
                                        {requireTime
                                            ? <input
                                                className={editFlag ? inputClass : inputReadOnlyClass}
                                                id="apptTime"
                                                onChange={(e) => onChangeEvent(e)}
                                                type="time"
                                                value={request.apptTime}
                                                required
                                                readOnly={!editFlag}
                                            />
                                            : <input className={inputReadOnlyClass} id="apptTimeTBDBox" value="TBD" readOnly />
                                        }
                                    </div>
                                    <div>
                                        <label htmlFor="apptTimeZone" className={labelClass}>Timezone</label>
                                        <select
                                            className={editFlag ? selectClass : inputReadOnlyClass}
                                            id="apptTimeZone"
                                            value={request.apptTimeZone}
                                            onChange={(e) => onChangeEvent(e)}
                                            disabled={!editFlag}
                                        >
                                            <option value="ET">Eastern</option>
                                            <option value="CT">Central</option>
                                            <option value="MT">Mountain</option>
                                            <option value="PT">Pacific</option>
                                            <option value="HT">Hawaii</option>
                                            <option value="AK">Alaska</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Address */}
                                <div className="mb-4">
                                    <label htmlFor="apptStreet" className={labelClass}>Address *</label>
                                    <input
                                        className={editFlag ? inputClass : inputReadOnlyClass}
                                        id="apptStreet"
                                        onChange={(e) => onChangeEvent(e)}
                                        type="text"
                                        value={request.apptStreet}
                                        required
                                        readOnly={!editFlag}
                                    />
                                </div>

                                {/* City, State, Zip */}
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                                    <div>
                                        <label htmlFor="apptCity" className={labelClass}>City *</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="apptCity"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="text"
                                            value={request.apptCity}
                                            required
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="apptState" className={labelClass}>State *</label>
                                        <select
                                            className={editFlag ? selectClass : inputReadOnlyClass}
                                            id="apptState"
                                            value={request.apptState}
                                            onChange={(e) => addState(e)}
                                            disabled={!editFlag}
                                            required
                                        >
                                            {stateOptions.map(state => (
                                                <option key={state} value={state}>
                                                    {state === '' ? 'Select State' : state}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label htmlFor="apptZip" className={labelClass}>Zip Code *</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="apptZip"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="tel"
                                            value={request.apptZip}
                                            required
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                </div>

                                {/* Fee and Lender */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label htmlFor="apptOffer" className={labelClass}>Offered Signing Agent Fee</label>
                                        <input
                                            className={notaryFeeEditFlag ? inputClass : inputReadOnlyClass}
                                            id="apptOffer"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="text"
                                            value={setFee()}
                                            required
                                            readOnly={!notaryFeeEditFlag}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="apptLender" className={labelClass}>Lender</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="apptLender"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="text"
                                            value={request.apptLender}
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                </div>

                                {/* Scan Back Required */}
                                <div className="border-t border-neutral-200 pt-4 mb-4">
                                    <label className="block text-sm font-medium text-neutral-700 mb-3">Scan Back Required?</label>
                                    <div className="flex flex-wrap gap-4">
                                        <label className="flex items-center">
                                            <input
                                                className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500"
                                                type="radio"
                                                name="scanBack"
                                                id="scanBackTrue"
                                                onChange={(e) => onChangeEvent(e)}
                                                value="true"
                                                checked={request.scanBack === 'true' || request.scanBack === true}
                                                required
                                                disabled={!editFlag}
                                            />
                                            <span className="ml-2 text-sm text-neutral-700">Required</span>
                                        </label>
                                        <label className="flex items-center">
                                            <input
                                                className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500"
                                                type="radio"
                                                name="scanBack"
                                                id="scanBackFalse"
                                                onChange={(e) => onChangeEvent(e)}
                                                value="false"
                                                checked={request.scanBack === 'false' || request.scanBack === false}
                                                required
                                                disabled={!editFlag}
                                            />
                                            <span className="ml-2 text-sm text-neutral-700">Not Required</span>
                                        </label>
                                    </div>
                                </div>

                                {/* Transaction Type */}
                                <div className="border-t border-neutral-200 pt-4 mb-4">
                                    <label className="block text-sm font-medium text-neutral-700 mb-3">Type of Transaction</label>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                        {[
                                            { value: '1', label: 'Purchase (Buyer Side)' },
                                            { value: '2', label: 'Refinance' },
                                            { value: '3', label: 'Seller Side Closing' },
                                            { value: '4', label: 'Other (Warranty deed, etc)' }
                                        ].map(item => (
                                            <label key={item.value} className="flex items-center">
                                                <input
                                                    className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500"
                                                    type="radio"
                                                    name="transactionType"
                                                    id={`transactionType${item.value}`}
                                                    onChange={(e) => onChangeEvent(e)}
                                                    value={item.value}
                                                    checked={request.transactionType === item.value}
                                                    required
                                                    disabled={!editFlag}
                                                />
                                                <span className="ml-2 text-sm text-neutral-700">{item.label}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {/* Finance Type */}
                                <div className="border-t border-neutral-200 pt-4 mb-4">
                                    <label className="block text-sm font-medium text-neutral-700 mb-3">Type of Financing (Optional)</label>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                                        {[
                                            { value: '11', label: 'FHA' },
                                            { value: '16', label: 'VA' },
                                            { value: '12', label: 'Conventional' },
                                            { value: '13', label: 'Reverse' },
                                            { value: '14', label: 'HELOC' },
                                            { value: '15', label: 'Commercial' }
                                        ].map(item => (
                                            <label key={item.value} className="flex items-center">
                                                <input
                                                    className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500"
                                                    type="radio"
                                                    name="financeType"
                                                    id={`financeType${item.value}`}
                                                    onChange={(e) => onChangeEvent(e)}
                                                    value={item.value}
                                                    checked={request.financeType === item.value}
                                                    disabled={!editFlag}
                                                />
                                                <span className="ml-2 text-sm text-neutral-700">{item.label}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {/* File Number */}
                                <div className="mb-4">
                                    <label htmlFor="fileNumber" className={labelClass}>File Number</label>
                                    <input
                                        className={editFlag ? inputClass : inputReadOnlyClass}
                                        id="fileNumber"
                                        onChange={(e) => onChangeEvent(e)}
                                        type="text"
                                        value={request.fileNumber}
                                        readOnly={!editFlag}
                                    />
                                </div>

                                {/* Assigned Signing Agent */}
                                <div className="mb-4">
                                    <label htmlFor="assigned_notary" className={labelClass}>Assigned Signing Agent</label>
                                    <input
                                        className={inputReadOnlyClass}
                                        id="assigned_notary"
                                        type="text"
                                        value={request.assigned_notary}
                                        readOnly
                                    />
                                </div>

                                {/* Comments */}
                                <div className="mb-4">
                                    <label htmlFor="comments" className={labelClass}>Additional Comments (max 400 characters)</label>
                                    <textarea
                                        ref={(el) => { commentsRef.current = el; if (el) autoResizeComments(el); }}
                                        className={editFlag ? inputClass : inputReadOnlyClass}
                                        id="comments"
                                        maxLength="400"
                                        onChange={(e) => onChangeEvent(e)}
                                        value={request.comments}
                                        readOnly={!editFlag}
                                        rows={1}
                                        style={{ resize: 'none', overflow: 'hidden', minHeight: 0 }}
                                        onInput={(e) => autoResizeComments(e.target)}
                                    />
                                </div>

                                {/* Title Company Info */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label htmlFor="email" className={labelClass}>Title Company Email</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="email"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="email"
                                            value={request.email}
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="appt_firm_name" className={labelClass}>Title Company</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="appt_firm_name"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="text"
                                            value={request.appt_firm_name}
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label htmlFor="appt_fee" className={labelClass}>Title Company Service Fee</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="appt_fee"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="text"
                                            value={setServiceFee()}
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="appt_escrow" className={labelClass}>Escrow Officer</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="appt_escrow"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="text"
                                            value={request.appt_escrow}
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                </div>

                                {/* Signer Contact Info */}
                                <div className="mb-4">
                                    <label htmlFor="contactName" className={labelClass}>Signer Contact Name</label>
                                    <input
                                        className={editFlag ? inputClass : inputReadOnlyClass}
                                        id="contactName"
                                        onChange={(e) => onChangeEvent(e)}
                                        type="text"
                                        value={request.contactName}
                                        readOnly={!editFlag}
                                    />
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label htmlFor="contactPhone1" className={labelClass}>Signer Phone 1</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="contactPhone1"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="tel"
                                            value={request.contactPhone1}
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="contactPhone2" className={labelClass}>Signer Phone 2</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="contactPhone2"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="tel"
                                            value={request.contactPhone2}
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label htmlFor="contactEmail1" className={labelClass}>Signer Email 1</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="contactEmail1"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="email"
                                            value={request.contactEmail1}
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="contactEmail2" className={labelClass}>Signer Email 2</label>
                                        <input
                                            className={editFlag ? inputClass : inputReadOnlyClass}
                                            id="contactEmail2"
                                            onChange={(e) => onChangeEvent(e)}
                                            type="email"
                                            value={request.contactEmail2}
                                            readOnly={!editFlag}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex flex-wrap gap-3">
                                {notaryFeeEditFlag ? (
                                    <button
                                        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                                        type="submit"
                                    >
                                        Preview
                                    </button>
                                ) : (
                                    <>
                                        <button
                                            className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                                            type="submit"
                                        >
                                            Update
                                        </button>
                                        <button
                                            className="bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors"
                                            type="button"
                                            onClick={() => updateEditFlags(true)}
                                        >
                                            Edit
                                        </button>
                                    </>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {isLoading && (
                <div className="flex justify-center my-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                </div>
            )}
        </Fragment>
    )
};

export default AdminEditCreatedRequest;
